import { KeepActions, type KeptRef } from '@/components/keep/KeepActions';
import { useKeepDriveFiles } from '@/hooks/useDrivesQueries';

export interface DriveKeepActionsProps {
  driveId: number;
  path: string;
  fileName: string;
  kept: KeptRef | null;
}

export function DriveKeepActions({ driveId, path, fileName, kept }: DriveKeepActionsProps) {
  const keepMutation = useKeepDriveFiles(driveId);

  return (
    <KeepActions
      kept={kept}
      onKeep={(anchorId) => keepMutation.mutate(anchorId !== undefined ? { paths: [path], anchorId } : { paths: [path] })}
      pending={keepMutation.isPending}
      error={keepMutation.error}
      description={fileName}
    />
  );
}
